import { Loader } from '@googlemaps/js-api-loader';

class GoogleMapsService {
  private loader: Loader;
  private isLoaded = false;

  constructor() {
    this.loader = new Loader({
      apiKey: `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
      libraries: ['places'],
    });
  }

  async load() {
    if (!this.isLoaded) {
      await this.loader.load();
      this.isLoaded = true;
    }
  }

  async createAutocomplete(
    input: HTMLInputElement,
    onPlaceSelected: (place: google.maps.places.PlaceResult) => void
  ) {
    await this.load();

    const autocomplete = new google.maps.places.Autocomplete(input, {
      fields: ['formatted_address', 'geometry', 'name'],
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      onPlaceSelected(place);
    });

    return autocomplete;
  }

  async getAddressByCoordinates(latitude: number, longitude: number): Promise<string | undefined> {
    await this.load();
    const geocoder = new google.maps.Geocoder();
    const response = await geocoder.geocode({ location: { lat: latitude, lng: longitude } });
    return response.results[0]?.formatted_address;
  }
}

export const googleMapsService = new GoogleMapsService();
